import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div className="sidebar">
        <h4 className="text-center py-3"><a className="navbar-brand" href="https://st.tjdstore.in"><img className="logoimg" alt="Logo" width={186} src="https://merch.tjdstore.in/images/dharmapanah_black_bg.png" /></a></h4>
        <ul>

                  <li className="nav-item">
                    <Link className="nav-link" to="/InvoiceForm">Invoice</Link>
                    <Link className="nav-link" to="/Products">All Product</Link>
                    <Link className="nav-link" to="/Invoiceview">View Invoice</Link>                    
                    <Link className="nav-link" to="/MasterReport">Master Report</Link>                                        
                  </li>

                </ul>
      </div>
    );
};

export default Header;
